<template>
  <div>
    <h2>2. Validaton Result</h2>

    <validation-order-data
      :orders="validationData.orders"
      :getStrategy="getStrategy"
      :getGroupNames="getGroupNames"
      v-if="validationData.usesOrders"
    ></validation-order-data>
    <validation-article-data
      :articles="validationData.articles"
      v-if="!validationData.usesOrders"
      :getStrategy="getStrategy"
      :getGroupNames="getGroupNames"
    >
    </validation-article-data>
    <div class="flex items-center justify-end w-full mt-4">
      <button
        class="flex items-center mr-8 text-lg text-white bg-transparent border-none cursor-pointer"
        type="button"
        v-on:click="goBack"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
            d="M15 19l-7-7 7-7"
          />
        </svg>
        Go back
      </button>
      <button
        type="button"
        class="flex items-center button primary"
        @click="importData"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
          />
        </svg>
        Import
      </button>
    </div>
  </div>
</template>

<script>
import ValidationArticleData from "./ValidationArticleData.vue";
import ValidationOrderData from "./ValidationOrderData.vue";

export default {
  components: { ValidationOrderData, ValidationArticleData },
  props: {
    validationData: Object,
    groups: Array,
    goBack: Function,
    importData: Function,
  },
  methods: {
    getStrategy(strategy) {
      switch (strategy) {
        case "MergeWithExisting":
          return "Merge With Existing";
        case "ReplaceExisting":
          return "Replace Existing";
        case "SkipExisting":
          return "Skip Existing";
        case "AppendWithUniqueName":
          return "Create With Unique Name";
        default:
          return "";
      }
    },
    getGroupNames(groupIds) {
      const childGroups = this.groups.flatMap(g => g.children);
      const subChildGroups = childGroups.flatMap(g => g.children);
      const allGroups = this.groups.concat(childGroups).concat(subChildGroups);
      const groups = allGroups.filter(x => groupIds.includes(x.id));
      return groups && groups.length
        ? groups.map(x => x.groupName).join(", ")
        : "";
    },
  },
};
</script>

<style>
.article-title {
  @apply w-full mb-2 text-lg font-bold pb-2 border-white;
  border-bottom: 1px solid;
}

.article-data-header {
  @apply w-full text-xs font-bold border-white pb-1;
  border-bottom: 1px solid;
}
</style>
